import { render, staticRenderFns } from "./WidgetSettingsDialog.vue?vue&type=template&id=e167119c"
import script from "./WidgetSettingsDialog.vue?vue&type=script&lang=js"
export * from "./WidgetSettingsDialog.vue?vue&type=script&lang=js"
import style0 from "./WidgetSettingsDialog.vue?vue&type=style&index=0&id=e167119c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports